module.exports = __webpack_public_path__ + "img/sooth.87d74e8a.jpg";